import { ActionGlobalNotifsBase, ActionTypesGlobalNotifs } from "./actionTypes";

interface IState {
  text: string;
  isIcon: boolean;
  isError: boolean;
  isLoading: boolean;
  timer?: number;
}

const initialState = {
  text: "",
  isIcon: true,
  isError: false,
  isLoading: false,
};

const reducer = (
  state = initialState,
  action: ActionGlobalNotifsBase
): IState => {
  switch (action.type) {
    case ActionTypesGlobalNotifs.SET_OK || ActionTypesGlobalNotifs.SET_INFO:
      return {
        ...state,
        text: action.payload,
        isError: false,
        isLoading: false,
      };
    case ActionTypesGlobalNotifs.SET_ERROR:
      return {
        ...state,
        text: action.payload.text,
        isError: true,
        isLoading: false,
        timer: action.payload.timer,
      };
    case ActionTypesGlobalNotifs.SET_LOADING:
      return {
        ...state,
        text: "",
        isLoading: action.payload,
        isError: false,
      };
    case ActionTypesGlobalNotifs.CLEAR:
      return {
        ...state,
        text: "",
        isError: false,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default reducer;
